/**
 * Expert-review route tree.
 *
 * Belongs here: Route definitions and layout wrapper.
 * Paths: expertReviewPaths.ts — navigation: expertReviewNavigation.tsx.
 * First-status hub redirect: ExpertReviewInitialStatusGate.
 */
import { Outlet, Route } from 'react-router-dom'
import ExpertReviewProviders from '../providers/ExpertReviewProviders'
import ExpertReviewHubPage from '../hub/ExpertReviewHubPage'
import ExpertReviewSubmitPage from '../ExpertReviewSubmitPage'
import AllocationStrategyQuestionnairePage from '../strategy-questionnaire/pages/StrategyQuestionnairePage'
import StrategyQuestionnaireReviewPage from '../strategy-questionnaire/pages/StrategyReviewPage'
import AllocationRiskProfilePage from '../strategy-questionnaire/pages/StrategyRiskProfilePage'
import AllocationPreferencesListPage from '../preferences/pages/PreferencesListPage'
import AllocationPreferencesQuestionnairePage from '../preferences/pages/PreferencesQuestionnairePage'
import AllocationPreferencesPreferenceTypeQuestionnairePage from '../preferences/pages/PreferencesTypeQuestionnairePage'
import AllocationPreferencesReviewPage from '../preferences/pages/PreferencesReviewPage'
import { EXPERT_REVIEW_ROUTES, EXPERT_REVIEW_ROUTE_SEGMENTS } from './expertReviewPaths'

function ExpertReviewLayout() {
  return (
    <ExpertReviewProviders>
      <Outlet />
    </ExpertReviewProviders>
  )
}

export const ExpertReviewRoutes = () => {
  return [
    <Route key="expert-review" path={EXPERT_REVIEW_ROUTES.root} element={<ExpertReviewLayout />}>
      <Route index element={<ExpertReviewHubPage />} />
      <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.review} element={<ExpertReviewSubmitPage />} />
      <Route
        key="expert-review-strategy"
        path={EXPERT_REVIEW_ROUTE_SEGMENTS.strategy.root}
      >
        <Route index element={<AllocationStrategyQuestionnairePage />} />
        <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.strategy.riskProfile} element={<AllocationRiskProfilePage />} />
        <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.strategy.review} element={<StrategyQuestionnaireReviewPage />} />
        <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.strategy.stageIdParam} element={<AllocationStrategyQuestionnairePage />} />
      </Route>,
      <Route
        key="expert-review-preferences"
        path={EXPERT_REVIEW_ROUTE_SEGMENTS.preferences.root}
      >
        <Route index element={<AllocationPreferencesListPage />} />
        <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.preferences.questionnaire} element={<AllocationPreferencesQuestionnairePage />} />
        <Route
          path={EXPERT_REVIEW_ROUTE_SEGMENTS.preferences.typeWithParam}
          element={<AllocationPreferencesPreferenceTypeQuestionnairePage />}
        />
        <Route path={EXPERT_REVIEW_ROUTE_SEGMENTS.preferences.review} element={<AllocationPreferencesReviewPage />} />
      </Route>
    </Route>
  ]
}
